const VERSION = process.env.REACT_APP_VERSION || require('../package.json').version;
const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '';

export const appVersion = BUILD_DATE
  ? `v${VERSION} (${BUILD_DATE})`
  : `v${VERSION}`;
